import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { HTMLAttributes } from 'react';

type Variant = 'primary' | 'outline' | 'outline-small' | 'dot';

interface Props extends HTMLAttributes<HTMLSpanElement> {
    variant?: Variant;
    color?: string;
    textColor?: string;
}

function Badge(props: Props) {
    const {
        variant = 'primary',
        textColor = 'white',
        color = 'var(--color-primary)',
        style,
        ...rest
    } = props;
    const isOutline = (variant === 'outline' || variant === 'outline-small');
    const badgeStyle = {
        color: isOutline ? color : textColor,
        backgroundColor: isOutline ? 'transparent' : color,
        borderColor: isOutline ? color : 'transparent',
    };
    return <Base aria-label='badge'
        variant={variant}
        style={{ ...badgeStyle, ...style }}
        {...rest}
    />;
}

const VARIANT_STYLES: Record<Variant, ReturnType<typeof css>> = {
    primary: css`
        font-size: 13px;
        height: 28px;
        line-height: 20px;
        width: 64px;
    `,
    dot: css`
        font-size: 10px;
        font-weight: bold;
        height: 13px;
        width: 16px;
    `,
    outline: css`
        background-color: transparent;
        border: 1px solid;
        font-size: 12px;
        font-weight: bold;
        line-height: 1.4;
        padding: 1px 7px;
    `,
    'outline-small': css`
        background-color: transparent;
        font-size: 11px;
        font-weight: bold;
        height: 17px;
        width: 34px;
        border: 1px solid;
    `,
};

const Base = styled.span<{
    variant: Variant;
}>`
    align-items: center;
    border-radius: 14px;
    display: flex;
    justify-content: center;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
    text-wrap: nowrap;
    ${({ variant }) => VARIANT_STYLES[variant]}
`;

export default Badge;
